import { render, staticRenderFns } from "./InvitationSentModal.vue?vue&type=template&id=58b67b28&scoped=true&"
import script from "./InvitationSentModal.vue?vue&type=script&lang=js&"
export * from "./InvitationSentModal.vue?vue&type=script&lang=js&"
import style0 from "./InvitationSentModal.vue?vue&type=style&index=0&id=58b67b28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b67b28",
  null
  
)

export default component.exports